import React, { useEffect, useRef, useState } from "react";

const AVISO_EMBED_URL = "https://atria.la/aviso-embed";
// Si el iframe no carga en este tiempo (página caída, sin red, bloqueo), se
// muestra el texto de respaldo.
const TIMEOUT_MS = 8000;

const AvisoPrivacidadContenido = () => {
  // "cargando" -> "ok" (iframe cargó) | "error" (falló y se usa el respaldo)
  const [estado, setEstado] = useState("cargando");
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setEstado((prev) => (prev === "cargando" ? "error" : prev));
    }, TIMEOUT_MS);
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleLoad = () => {
    clearTimeout(timeoutRef.current);
    setEstado("ok");
  };

  const handleError = () => {
    clearTimeout(timeoutRef.current);
    setEstado("error");
  };

  if (estado !== "error") {
    return (
      <>
        {estado === "cargando" && (
          <p className="texto-informacion text-start">
            Cargando aviso de privacidad...
          </p>
        )}
        <iframe
          title="Aviso de Privacidad"
          src={AVISO_EMBED_URL}
          onLoad={handleLoad}
          onError={handleError}
          style={{
            width: "100%",
            height: estado === "ok" ? "65vh" : 0,
            border: "none",
          }}
        />
      </>
    );
  }

  return (
    <>
      <h2 className="texto-subtitulo">AVISO DE PRIVACIDAD</h2>
      <h2 className="texto-subtitulo">ATRIALA, S.A.P.I. de C.V.</h2>
    <p className="texto-informacion text-start">
      1. RESPONSABLE DE LOS DATOS PERSONALES
      <br />
      <br />
      ATRIALA, S.A.P.I. de C.V., (En lo sucesivo “ATRIA”) con domicilio en Av. Pdte. Masaryk 29 (Piso 9-B), Polanco V sección, Miguel Hidalgo, Ciudad de México, C.P. 11560, en cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y demás normatividad relativa y aplicable (en adelante, de manera conjunta, la “Ley”), es responsable de la recolección, uso, almacenamiento, tratamiento y transferencia de los datos personales que sean recabados de manera directa o indirecta, con motivo de las finalidades que se señalan en este Aviso de Privacidad, garantizando de esta forma que el tratamiento de sus datos personales se lleva a cabo de manera legítima, controlada e informada, preservando su derecho a la privacidad y a la autodeterminación informativa.
      <br />
      <br />
      2. DATOS PERSONALES
      <br />
      <br />
      De conformidad con la Ley y para efectos de este Aviso de Privacidad, se entenderán por datos personales: cualquier información concerniente a una persona identificada o identificable (los “Datos Personales”). El tipo de Datos Personales que ATRIA podrá solicitar a la persona titular (en lo sucesivo, el “Titular” o los “Titulares”), incluye los siguientes:
      <br />
      <br />
      Datos generales de identificación:
      <br />
      <br />
      Nombre completo, domicilio, estado civil, Clave Única de Registro de Población (“CURP”), Registro Federal de Contribuyentes (“RFC”), lugar y fecha de nacimiento, nacionalidad y género (adicionalmente, documentos que acrediten los datos generales de identificación).
      <br />
      <br />
      Datos de contacto:
      <br />
      <br />
      Correo electrónico, número de teléfono celular y número de teléfono fijo.
      <br />
      <br />
      Datos académicos:
      <br />
      <br />
      Nivel de estudios.
      <br />
      <br />
      Datos laborales:
      <br />
      <br />
      Actividad u ocupación, empresa o dependencia en la que labora, antigüedad, puesto y domicilio del lugar de trabajo.
      <br />
      <br />
      Datos patrimoniales:
      <br />
      <br />
      Ingreso mensual.
      <br />
      <br />
      Información crediticia: En caso de solicitar un financiamiento se revisará el buró de crédito del Titular.
      <br />
      <br />
      2.1. DATOS PERSONALES SENSIBLES
      <br />
      <br />
      Le informamos que ATRIA realiza el tratamiento de los siguientes datos personales sensibles:
      <br />
      <br />
      Datos biométricos:
      <br />
      <br />
      Huellas dactilares (coincidencia de datos ante el Instituto Nacional Electoral).
      <br />
      <br />
      Datos de geolocalización:
      <br />
      <br />
      ATRIA puede recopilar, almacenar o procesar cierta información de geolocalización vehicular. Por lo tanto, para su tratamiento deberá otorgar su consentimiento expreso y por escrito, mediante firma autógrafa o electrónica del presente Aviso de Privacidad.
      <br />
      <br />
      En este sentido, al firmar este documento, usted consiente expresamente el tratamiento de los datos personales sensibles mencionados anteriormente, de conformidad con lo establecido por el artículo 8 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
      <br />
      <br />
      2.2. DATOS DE TERCEROS
      <br />
      <br />
      ATRIA solicita la siguiente información de terceros: (i) para dar cumplimiento a las disposiciones de Beneficiario Controlador de la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita; y (ii) de referencias personales de los Titulares: Del Beneficiario Controlador y su Representante Legal.
      <br />
      <br />
      Datos generales de identificación: Nombre completo, domicilio, estado civil, Clave Única de Registro de Población (“CURP”), Registro Federal de Contribuyentes (“RFC”), lugar y fecha de nacimiento, nacionalidad y género (adicionalmente, documentos que acrediten los datos generales de identificación).
      <br />
      <br />
      De Referencias Personales: Nombre, Número de teléfono.
      <br />
      <br />
      El Titular manifiesta que previamente a compartirlos con ATRIA, obtuvo el consentimiento por parte de estos terceros para que ATRIA pueda dar tratamiento y/o remisión de dichos Datos Personales.
      <br />
      <br />
      3. FINALIDADES DEL TRATAMIENTO DE DATOS
      <br />
      <br />
      La información que sea proporcionada por el Titular a ATRIA, conforme al presente Aviso de Privacidad, tendrá las finalidades siguientes:
      <br />
      <br />
      3.1 FINALIDADES PRIMARIAS
      <br />
      <br />
      Identificar la identidad de la persona solicitante de alguno de los productos ofertados por ATRIA;
      <br />
      <br />
      Realizar la verificación de los datos contenidos en la Credencial para Votar y en su caso, huellas dactilares del solicitante en la base de datos personales del Instituto Nacional Electoral, exclusivamente para obtener una confirmación de coincidencia de datos, sin que ello implique en forma alguna la entrega de estos. Verificar y validar la identidad del Titular con documentación oficial, así como la información proporcionada por el Titular para la contratación de los productos ofertados por ATRIA;
      <br />
      <br />
      Recabar copia de la información presentada por el Titular para generar y organizar un expediente y dar cumplimiento a diversas disposiciones legales;
      <br />
      <br />
      Llevar a cabo gestiones relativas a otorgamiento y cobro de créditos; Implementar las actividades inherentes al cobro de adeudos o retrasos en pagos;
      <br />
      <br />
      Consultar el historial crediticio del Titular ante las sociedades de información crediticia autorizadas. Comunicar la calificación del historial crediticio, a empresas subsidiarias, filiales, controladoras o terceros, para otorgar o denegar el crédito solicitado, gestionar la contratación de seguros por ATRIA y/o por el Titular que sean obligatorios de conformidad con los términos de los productos o servicios. Enviar facturas al domicilio y/o correo electrónico de los Titulares que lo soliciten;
      <br />
      <br />
      Realizar actividades de soporte y aclaraciones para el Titular; Llevar a cabo auditorías internas y externas;
      <br />
      <br />
      Validar las condiciones financieras de las personas que presentan adeudos o retrasos en pagos;
      <br />
      <br />
      Prevenir y detectar fraudes u otros ilícitos; Dar cumplimiento a la normatividad en materia de prevención de lavado de dinero;
      <br />
      <br />
      Confirmar la identidad del Titular mediante el tratamiento de los datos biométricos señalados anteriormente. Tratar los datos de geolocalización, para capturar y almacenar la información geográfica;
      <br />
      <br />
      Mantener la información de los Titulares debidamente actualizada; Elaborar estadísticas de carácter interno, para identificar el comportamiento de uso del sitio web de ATRIA, así como las preferencias de consumo de los productos y servicios. El cumplimiento de leyes, reglamentos y disposiciones legales aplicables.
      <br />
      <br />
      3.2. FINALIDADES SECUNDARIAS
      <br />
      <br />
      Realizar llamadas a los Titulares que contratan un producto o servicio;
      <br />
      <br />
      Realizar encuestas sobre la calidad del servicio prestado por ATRIA;
      <br />
      <br />
      Realizar actividades de mercadotecnia, publicidad, promoción y telemarketing, de los bienes, productos y/o servicios que sean ofrecidos por ATRIA, por cualquier medio material y/o electrónico. Negociar o celebrar operaciones de cesión, descuento o factoraje de los derechos de cobro que ATRIA tenga respecto de créditos otorgados a los Titulares.
      <br />
      <br />
      Negociar o celebrar operaciones de cesión, descuento o factoraje de los derechos de cobro que ATRIA tenga respecto de créditos otorgados a los Titulares;
      <br />
      <br />
      Permitir que las instituciones financieras, cesionarias o adquirentes de los derechos de cobro derivados de los créditos otorgados al Titular, así como sus subsidiarias, filiales y controladoras, lleven a cabo actividades de mercadotecnia, publicidad, promoción y telemarketing de sus propios bienes, productos y servicios financieros, por cualquier medio material o electrónico, contactando al Titular para tales efectos. El Titular podrá oponerse a esta finalidad en cualquier momento mediante solicitud dirigida al cesionario, adquirente o institución financiera correspondiente, o bien a ATRIA al correo privacidad@atria.la, en cuyo caso ATRIA escalará la oposición al cesionario, adquirente o institución financiera respectiva en un plazo no mayor a 10 (diez) Días Hábiles para que sea respetada.
      <br />
      <br />
      En caso de que no desee que sus datos personales sean tratados para estas finalidades secundarias, podrá solicitarlo mediante el envío de un correo electrónico a la dirección privacidad@atria.la.
      <br />
      <br />
      4. TRANSFERENCIAS DE DATOS PERSONALES
      <br />
      <br />
      Con el propósito de dar cumplimiento a las finalidades establecidas en el presente Aviso de Privacidad, ATRIA le informa que los Datos Personales de los Titulares podrán ser transferidos o remitidos a otras empresas distintas a ATRIA o, en su defecto, a subsidiarias, filiales o controladoras; en este sentido, hacemos de su conocimiento que ATRIA transfiere sus datos personales únicamente en los casos siguientes:
      <br />
      <br />
      Al Instituto Nacional Electoral, para verificar la autenticidad de los datos contenidos en la Credencial para Votar, y similitud de huellas dactilares proporcionados por el Titular respecto de su identidad.
      <br />
      <br />
      A subsidiarias, filiales o controladoras de ATRIA, para llevar a cabo la operación y administración de los créditos contratados, de conformidad con los términos y condiciones de dichos documentos.
      <br />
      <br />
      A las Sociedades de Información Crediticia, para obtener su reporte de crédito. Para dar a conocer la calificación del historial crediticio a empresas subsidiarias, filiales, controladoras o terceros, para otorgar o denegar el crédito solicitado.
      <br />
      <br />
      Al Servicio Postal Mexicano, para realizar el envío de facturas de los Titulares que así lo soliciten.
      <br />
      <br />
      A las aseguradoras contratadas por el Titular, para la elaboración de dictámenes de siniestros.
      <br />
      <br />
      A los proveedores que presten servicios a ATRIA; incluyendo servicios de auditoría externa.
      <br />
      <br />
      A instituciones financieras o terceros, cuando ATRIA esté negociando y/o lleve actos en virtud de los cuales ceda, transmita, transfiera, afecte, grave o negocie, en cualquier forma, derechos de crédito que se registren de conformidad con los términos de los contratos celebrados por los Titulares; o en los pagarés suscritos al amparo de los mismos contratos por el Titular; o cuando ATRIA celebre fusiones o escisiones en las que el Titular se vea involucrado. Los cesionarios, adquirentes o instituciones financieras a las que se realice cualquiera de las transferencias previstas en este párrafo quedan expresamente facultados, una vez efectuada la transferencia respectiva, para tratar los Datos Personales del Titular (i) para las finalidades de administración y cobro de los derechos de crédito cedidos o transferidos, y (ii) para las finalidades secundarias de mercadotecnia, publicidad, promoción y telemarketing de sus propios bienes, productos y servicios financieros, en los términos previstos en la Sección 3.2 del presente Aviso de Privacidad. El Titular podrá oponerse en cualquier momento a las finalidades secundarias mercadotécnicas dirigiendo su solicitud al cesionario, adquirente o institución financiera correspondiente, o bien a ATRIA al correo privacidad@atria.la, debiendo ATRIA escalar la oposición al cesionario, adquirente o institución financiera respectiva en un plazo no mayor a 10 (diez) Días Hábiles.
      <br />
      <br />
      A la autoridad competente, en caso de que ésta solicite legalmente sus datos personales. En caso de una fusión o escisión, a la empresa que adquiera las obligaciones legales al llevar a cabo la unión o separación de ATRIA.
      <br />
      <br />
      Aunado a lo anterior, de acuerdo a lo dispuesto por la Ley, ATRIA hará remisiones de los Datos Personales del Titular para cumplir las obligaciones derivadas de la relación jurídica con proveedores de servicios, o socios comerciales, con quienes ATRIA tiene una relación jurídica, que derivado de dicha relación jurídica necesiten conocer la información y que asumen el compromiso de mantener la información bajo un estricto orden de confidencialidad y seguridad, cumpliendo los términos y condiciones del presente Aviso de Privacidad.
      <br />
      <br />
      Asimismo, ATRIA podrá en todo momento revelar y transmitir Información cuando por mandato de ley y/o de autoridad competente sea obligatorio o le fuere requerido, o por considerar de buena fe que dicha revelación es necesaria para: i) Cumplir con procesos legales; ii) Responder reclamaciones que involucren cualquier contenido que menoscabe derechos de terceros; iii) Proteger los derechos, la propiedad o la seguridad de ATRIA, sus usuarios y público en general; y iv) Cuando la transferencia esté prevista en una Ley o Tratado en los que México sea parte. ATRIA podrá proporcionar la Información a cualquier autoridad que le requiera la misma, para interponer cualquier medio de defensa en su favor, para establecer medidas de protección en contra de actividades ilícitas o situaciones que impliquen riesgo a la seguridad de cualquier persona, y cualquier otra actividad que la ley o alguna autoridad requiera.
      <br />
      <br />
      5. DERECHOS A.R.C.O.
      <br />
      <br />
      El Titular de los Datos Personales proporcionados a ATRIA es responsable, en todo momento, de la veracidad, exactitud, vigencia y autenticidad de la información facilitada, y se compromete a mantenerla debidamente actualizada. Asimismo, el Titular cuenta con el derecho de acceder, rectificar, cancelar u oponerse al tratamiento de sus Datos Personales (en adelante, los “Derechos ARCO”) en los casos que así lo prevé la Ley; o bien, revocar su consentimiento. El Titular deberá considerar que para ciertos fines, la revocación del consentimiento al tratamiento de sus Datos Personales, implicará que ATRIA no pueda seguir prestando el servicio solicitado por el Titular.
      <br />
      <br />
      Si el Titular desea ejercer alguno de los Derechos ARCO, podrá realizarlo mediante escrito presentado en las oficinas de ATRIA, ubicadas en Av. Pdte. Masaryk 29 (Piso 9-B), Polanco V sección, Miguel Hidalgo, Ciudad de México, C.P. 11560, o al correo electrónico privacidad@atria.la, debiendo confirmar la recepción de dicho documento en el teléfono 55 4440 5546 en un horario de atención de lunes a viernes de 10:00 a 19:00 horas, en días hábiles, según corresponda.
      <br />
      <br />
      La solicitud deberá considerar los siguientes requisitos:
      <br />
      <br />
      Nombre completo del Titular, domicilio y correo electrónico para recibir notificaciones.
      <br />
      <br />
      Los documentos que acrediten la identidad del Titular o, en su caso, la personalidad e identidad de su representante.
      <br />
      <br />
      La descripción clara y precisa de los Datos Personales respecto de los que se busca ejercer alguno de los Derechos ARCO, salvo que se trate del derecho de acceso; la descripción del derecho ARCO que se pretende ejercer, o bien, lo que solicita el Titular; y cualquier otro elemento o documento que facilite la localización de los Datos Personales.
      <br />
      <br />
      ATRIA dará respuesta a la solicitud dentro de los veinte días siguientes contados a partir de que reciba la solicitud del Titular, plazo que podrá ser ampliado de acuerdo a lo dispuesto por el artículo 31 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
      <br />
      <br />
      La obligación de acceso a la información se dará por cumplida cuando se pongan a disposición del Titular los Datos Personales; o bien, mediante la expedición de documentos electrónicos, conforme al procedimiento correspondiente.
      <br />
      <br />
      6. USO DE COOKIES, WEB BEACONS Y OTRAS TECNOLOGÍAS
      <br />
      <br />
      El portal de Internet de ATRIA www.atria.la (en adelante, el “Portal”), emplea cookies, web beacons y otras tecnologías, los cuales son archivos de datos que se almacenan en su disco duro al navegar en el Portal y que permiten intercambiar información del estado del Portal y el navegador del Titular. A través de las cookies, ATRIA mide la información sobre el Titular que visita el Portal, información geográfica desde la que el Titular ingresa al Portal, así como el sistema operativo y el navegador. De igual forma, ATRIA recaba el promedio de tiempo de navegación y las estadísticas de las páginas más visitadas del Titular. ATRIA obtiene los datos antes referidos con la finalidad de conocer el comportamiento del Titular que son impactados mediante canales digitales externos al Portal o que entran de forma directa. El Titular podrá desactivar o bloquear el uso de cookies, web beacons y otras tecnologías, para lo cual deberá hacerlo de conformidad con las instrucciones señaladas por cada navegador o plataforma en la que el Titular acceda al Portal.
      <br />
      <br />
      7. MODIFICACIONES AL AVISO DE PRIVACIDAD
      <br />
      <br />
      Cualquier cambio o actualización en el presente Aviso de Privacidad, podrá ser consultado directamente en el Portal, en la sección “Aviso de Privacidad”.
      <br />
      <br />
      En caso de que el presente Aviso de Privacidad sea modificado respecto del tratamiento de sus datos personales sensibles, ATRIA se pondrá en contacto con el Titular a fin de obtener nuevamente su consentimiento expreso y por escrito, en cumplimiento a la Ley.
      <br />
      <br />
      8. AUTORIDAD DE PROTECCIÓN DE DATOS
      <br />
      <br />
      Si el Titular considera que su derecho a la protección de datos personales ha sido lesionado por alguna conducta u omisión de parte de ATRIA, podrán acudir ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI), mediante su página oficial de Internet www.inai.org.mx.
      <br />
      <br />
      9. MODIFICACIONES AL AVISO DE PRIVACIDAD
      <br />
      <br />
      Cualquier cambio o actualización en el presente Aviso de Privacidad, podrá ser consultado directamente en el Portal, en la sección “Aviso de Privacidad”.
      <br />
      <br />
      En caso de que el presente Aviso de Privacidad sea modificado respecto del tratamiento de sus datos personales sensibles, ATRIA se pondrá en contacto con el Titular a fin de obtener nuevamente su consentimiento expreso y por escrito, en cumplimiento a la Ley.
      <br />
      <br />
      10. CONSENTIMIENTO EXPRESO
      <br />
      <br />
      El Titular de los Datos Personales proporcionados a ATRIA, manifiesta que ha leído y entendido el presente Aviso de Privacidad, aceptando las categorías de Datos Personales recabados, incluidas las categorías relativas a datos patrimoniales y datos personales sensibles, así como las finalidades para el tratamiento de sus Datos Personales, otorgando en este momento de manera libre e informada su consentimiento expreso.
      <br />
      <br />
      Mediante la firma autógrafa o electrónica del presente documento, el Titular otorga su consentimiento expreso y por escrito de conformidad con lo establecido por el artículo 8 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, dando autorización para el tratamiento de sus datos personales sensibles.
    </p>
    </>
  );
};

export default AvisoPrivacidadContenido;
